import { frontend } from '../../../config';
import { Button } from '../../../components/Button/Button';
import { showNotification } from '../../../helper/showNotification';
import Logger from '../../../logger';

type Props = {
  gameId: string | undefined;
};

const ButtonShareGameLink = ({ gameId }: Props) => {
  const label = 'Link teilen';
  const link = frontend.host + '/game/join?gameId=' + gameId;

  const shareLink = () => {
    if (navigator.share) {
      navigator
        .share({
          title: 'quizzy-booze',
          text: 'Join our game:',
          url: link,
        })
        .then(() => Logger.info('Successful share'))
        .catch((error) => {
          showNotification('Error sharing', 'error');
          Logger.error(error);
        });
    } else {
      const isMobileOrTablet = /(android|iphone|ipad|mobile)/i.test(
        navigator.userAgent
      );
      const whatsappUrl =
        'https://' +
        (isMobileOrTablet ? 'api' : 'web') +
        '.whatsapp.com/send?text=' +
        encodeURI('Join our game:') +
        '%0a%0a' +
        link;
      window.open(whatsappUrl, '_blank', 'noreferrer');
    }
  };

  if (!gameId) {
    showNotification('GameId not available', 'warn');
    return <></>;
  }

  return <Button onClick={shareLink}>{label}</Button>;
};

export default ButtonShareGameLink;
